export const joinClasses = (classNames: string[]) => classNames.filter(Boolean).join(" ");